import React from "react";
import { Typography } from "@mui/material";

const AedPrice = ({
  price,
  variant = "h4",
  color = "secondary",
  className = "",
  ...props
}) => {
  // Format price with thousands separator
  const formatPrice = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Typography
      variant={variant}
      color={color}
      className={className}
      sx={{
        fontFamily: "dirham",
        verticalAlign: "baseline",
        "& span.dirham-symbol": {
          fontSize: "70%", // Slightly smaller dirham symbol
          marginRight: 1,
        },
        ...props.sx,
      }}
      {...props}
    >
      <span className="dirham-symbol">&#xe900;</span>
      {formatPrice(price)}
    </Typography>
  );
};

export default AedPrice;
